var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_17144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4131 14.4006C27.4131 13.4167 27.3272 12.4707 27.1677 11.5625H14.4531V16.9296H21.7186C21.4056 18.664 20.4545 20.1335 19.0247 21.1173V24.5987H23.3877C25.9404 22.1832 27.4131 18.6261 27.4131 14.4006Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4528 27.9604C18.0978 27.9604 21.1537 26.718 23.3873 24.5989L19.0244 21.1175C17.8155 21.95 16.2691 22.442 14.4528 22.442C10.9366 22.442 7.96049 20.0012 6.8989 16.7217H2.38867V20.3166C4.61004 24.8512 9.17549 27.9604 14.4528 27.9604Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89926 16.7219C6.62926 15.8894 6.47585 15.0001 6.47585 14.0856C6.47585 13.1711 6.62926 12.2819 6.89926 11.4494V7.85449H2.38903C1.47472 9.72762 0.953125 11.8467 0.953125 14.0856C0.953125 16.3245 1.47472 18.4436 2.38903 20.3168L6.89926 16.7219Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4528 5.72891C16.4348 5.72891 18.2144 6.42897 19.6134 7.80386L23.4855 3.82426C21.1475 1.58534 18.0916 0.210449 14.4528 0.210449C9.17549 0.210449 4.61004 3.31971 2.38867 7.85431L6.8989 11.4492C7.96049 8.16965 10.9366 5.72891 14.4528 5.72891Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_17144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.75,
    fill: "white",
    transform: "translate(0.953125 0.210449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5e36972ae93d844e7075a22e72e8190e.svg";
export { ForwardRef as ReactComponent };